import Insured from '@/modules/common/common/models/APP/Insured'
import { RaterAnswers } from '@/modules/common/rater/models/APP/RaterAnswers'
import { UserRoleEnum } from '@/modules/core/models/enums'

export default class TravelRaterAnswers extends RaterAnswers {
  insuranceType: number
  destinationType: number
  sportInsurance: boolean | undefined
  departureDate: Date
  returnDate: Date
  from: string
  cancellationCoverage: boolean | undefined = undefined

  constructor(data: any = {}) {
    super(data)

    this.forWhom = data.forWhom
    this.forWhomPeople = data.forWhomPeople ?? 1
    this.insuranceType = data.insuranceType
    this.destinationType = data.destinationType
    this.sportInsurance = data.sportInsurance
    this.departureDate = data.departureDate
    this.returnDate = data.returnDate
    this.from = data.from
    this.cancellationCoverage = data.cancellationCoverage
  }

  get holder(): Insured {
    if (super.holder) return super.holder
    const h = super.insureds.find((i) =>
      [UserRoleEnum.HOLDER_INSURED, UserRoleEnum.HOLDER_NOT_INSURED].includes(i.role)
    )
    return h ? h : new Insured({ role: UserRoleEnum.HOLDER_NOT_INSURED })
  }

  set holder(value: Insured | undefined) {
    super.holder = value
  }
}
